import type { AppRoute } from 'src/routes/types';

import { lazy } from 'react';

const ImplementationPlanView = lazy(
  () => import('./views/ImplementationPlanView.tsx')
);

export const implementationRoutePaths = {
  createImplementationPlan: '/clients/:id/implementation-plan',
} as const;

export const implementationRoutes: AppRoute[] = [
  {
    _dangerouslyInjectAsChildForLegacyPath: 'clients/:id',
    element: <ImplementationPlanView />,
    enabled: true,
    path: implementationRoutePaths.createImplementationPlan,
    permission: 'all',
    scope: 'private',
  },
];
